import * as TYPES from './action-types.js';
export default {
	namespaced: true,
	state: {
		user: null, // 用户信息{id, mobile}
		sessionId: null, // 微信授权sessionId
		captchaCountdown: 0, // 验证码倒计时
	},
	getters: {
		user: state => state.user,
		sessionId: state => state.sessionId,
		captchaCountdown: state => state.captchaCountdown
	},
	mutations: {
		[TYPES.USER__SET_CAPTCHA_COUNTDOWN](state, payload) {
			state.captchaCountdown = payload;
		},
		[TYPES.USER__SET_USER](state, payload) {
			state.user = payload;
		},
		[TYPES.USER__SET_SESSION_ID](state, payload) {
			state.sessionId = payload;
		}
	},
	actions: {
		[TYPES.USER__SET_CAPTCHA_COUNTDOWN]({commit}, payload) {
			commit(TYPES.USER__SET_CAPTCHA_COUNTDOWN, payload);
		},
		[TYPES.USER__SET_USER]({commit}, payload) {
			commit(TYPES.USER__SET_USER, payload);
		},
		[TYPES.USER__SET_SESSION_ID]({commit}, payload) {
			commit(TYPES.USER__SET_SESSION_ID, payload);
		}
	}
};
